import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[appToUpperCase]',
    standalone: false
})
export class ToUpperCaseDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initialValue.toUpperCase();

    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
